import React, { useState } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const CardTable = ({
  cards,
  selectedCards,
  onSelectCard,
  onSelectAll,
  onSort,
  sortConfig,
  onViewNFCCode,
  onEditAssignment,
  onToggleStatus,
  setCardId,
}) => {
  const [expandedCard, setExpandedCard] = useState(null);

  const getStatusColor = (status) => {
    const colors = {
      active: "bg-success/20 text-success",
      restricted: "bg-warning/20 text-warning",
      inactive: "bg-text-muted/20 text-text-muted",
    };
    return colors[status] || colors.inactive;
  };

  const getUserTypeColor = (userType) => {
    const colors = {
      individual: "bg-accent/20 text-accent",
      team: "bg-secondary/20 text-text-primary",
    };
    return colors[userType] || colors.individual;
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(amount);
  };

  const getSortIcon = (column) => {
    if (sortConfig.key !== column) {
      return <Icon name="ArrowUpDown" size={14} className="text-text-muted" />;
    }
    return sortConfig.direction === "asc" ? (
      <Icon name="ArrowUp" size={14} className="text-accent" />
    ) : (
      <Icon name="ArrowDown" size={14} className="text-accent" />
    );
  };

  const handleSort = (column) => {
    onSort(column);
  };

  const handleSelectCard = (card) => {
    console.log("Selected Card:", card);
    setCardId(card);
  };

  const isAllSelected =
    cards?.length > 0 && selectedCards?.length === cards.length;
  const isIndeterminate =
    selectedCards.length > 0 && selectedCards.length < cards.length;

  return (
    <div className="bg-surface border border-border rounded-lg overflow-hidden">
      {/* Desktop Table */}
      <div className="hidden lg:block overflow-x-auto">
        <table className="w-full">
          <thead className="bg-background border-b border-border">
            <tr>
              <th className="w-12 px-4 py-3">
                <div className="flex items-center justify-center">
                  <input
                    type="checkbox"
                    checked={isAllSelected}
                    ref={(el) => {
                      if (el) el.indeterminate = isIndeterminate;
                    }}
                    onChange={onSelectAll}
                    className="w-4 h-4 text-accent bg-background border-border rounded focus:ring-accent focus:ring-2"
                  />
                </div>
              </th>

              <th className="px-4 py-3 text-left">
                <button
                  className="flex items-center space-x-1 text-sm font-medium text-text-primary hover:text-accent transition-colors duration-150"
                >
                  <span>SL</span>
                </button>
              </th>
              <th className="px-4 py-3 text-left">
                <button
                  onClick={() => handleSort("cardId")}
                  className="flex items-center space-x-1 text-sm font-medium text-text-primary hover:text-accent transition-colors duration-150"
                >
                  <span>Card ID</span>
                  {getSortIcon("cardId")}
                </button>
              </th>

              <th className="px-4 py-3 text-left">
                <button
                  onClick={() => handleSort("assignedUser")}
                  className="flex items-center space-x-1 text-sm font-medium text-text-primary hover:text-accent transition-colors duration-150"
                >
                  <span>Assigned User</span>
                  {getSortIcon("assignedUser")}
                </button>
              </th>

              <th className="px-4 py-3 text-left">
                <button
                  onClick={() => handleSort("status")}
                  className="flex items-center space-x-1 text-sm font-medium text-text-primary hover:text-accent transition-colors duration-150"
                >
                  <span>Status</span>
                  {getSortIcon("status")}
                </button>
              </th>

              <th className="px-4 py-3 text-left">
                <button
                  onClick={() => handleSort("registrationDate")}
                  className="flex items-center space-x-1 text-sm font-medium text-text-primary hover:text-accent transition-colors duration-150"
                >
                  <span>Registration Date</span>
                  {getSortIcon("registrationDate")}
                </button>
              </th>

              <th className="px-4 py-3 text-right">
                <span className="text-sm font-medium text-text-primary">
                  Actions
                </span>
              </th>
            </tr>
          </thead>

          <tbody className="divide-y divide-border">
            {cards.map((card, i) => (
              <tr
                key={card._id}
                className={`hover:bg-hover transition-colors duration-150 ${
                  selectedCards.includes(card._id) ? "bg-accent/5" : ""
                }`}
              >
                <td className="px-4 py-3">
                  <div className="flex items-center justify-center">
                    <input
                      type="checkbox"
                      checked={selectedCards.includes(card._id)}
                      onChange={() => onSelectCard(card._id)}
                      className="w-4 h-4 text-accent bg-background border-border rounded focus:ring-accent focus:ring-2"
                    />
                  </div>
                </td>

                <td>
{i+1}
                </td>

                <td className="px-4 py-3">
                  <div className="font-mono text-sm font-medium text-text-primary">
                    {card?.hcId}
                  </div>
                  <div className="text-xs text-text-muted">
                    {" "}
                    {card?.connected ? "Connected" : "Available"}
                  </div>
                </td>

                {card?.content ? (
                  <td className="px-4 py-3">
                    <div className="flex items-center space-x-2">
                      <div className="w-8 h-8 bg-accent/20 rounded-full flex items-center justify-center">
                        <Icon name="User" size={14} className="text-accent" />
                      </div>
                      <div>
                        <div className="text-sm font-medium text-text-primary">
                          {card?.content?.name}
                        </div>
                        <div className="flex items-center space-x-2">
                          <span
                            className={`px-2 py-0.5 rounded-full text-xs font-medium ${getUserTypeColor(
                              card.userType
                            )}`}
                          >
                            {card?.contactInfo?.email?.value}
                          </span>
                          {card.department && (
                            <span className="text-xs text-text-muted">
                              {card.department}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </td>
                ) : (
                  <td className="px-4 py-3">
                    <p>Un assigned</p>
                  </td>
                )}

                <td className="px-4 py-3">
                  <span
                    className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(
                      card.status
                    )}`}
                  >
                    {card.status === 0
                      ? "Active"
                      : card.status === 1
                      ? "Restricted"
                      : "Inactive"}
                  </span>
                </td>

                <td className="px-4 py-3">
                  <div className="text-sm text-text-primary">
                    {formatDate(card?.createdAt)}
                  </div>
                </td>

                <td className="px-4 py-3">
                  <div className="flex items-center justify-end space-x-2">
                    <Button
                      variant="ghost"
                      onClick={() => onViewNFCCode(card)}
                      className="p-2"
                      title="View NFC Code"
                    >
                      <Icon name="QrCode" size={16} />
                    </Button>

                    <Button
                      variant="ghost"
                      onClick={() => onEditAssignment(card)}
                      className="p-2"
                      title="Edit Assignment"
                    >
                      <Icon name="Edit" size={16} />
                    </Button>

                    <Button
                      variant="ghost"
                      onClick={() => onToggleStatus(card)}
                      className="p-2"
                      title={
                        card.status === "active"
                          ? "Restrict Card"
                          : "Activate Card"
                      }
                    >
                      <Icon
                        name={card.status === "active" ? "Ban" : "CheckCircle"}
                        size={16}
                        className={
                          card.status === "active"
                            ? "text-warning"
                            : "text-success"
                        }
                      />
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile Card Layout */}
      <div className="lg:hidden divide-y divide-border">
        {cards.map((card) => (
          <div key={card._id} className="p-4">
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-center space-x-3">
                <input
                  type="checkbox"
                  checked={selectedCards.includes(card._id)}
                  onChange={() => onSelectCard(card._id)}
                  className="w-4 h-4 text-accent bg-background border-border rounded focus:ring-accent focus:ring-2 mt-1"
                />
                <div>
                  <div className="font-mono text-sm font-medium text-text-primary">
                    {card?.hcId}
                  </div>
                  <div className="text-xs text-text-muted">
                    {card?.content?.name || "In active Card"}
                  </div>
                </div>
              </div>

              <span
                className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(
                  card.status
                )}`}
              >
                {card.status}
              </span>
            </div>

            <div className="space-y-2 mb-4">
              <div className="flex items-center space-x-2">
                <Icon name="User" size={14} className="text-text-muted" />
                <span className="text-sm text-text-primary">
                  {card.assignedUser}
                </span>
                <span
                  className={`px-2 py-0.5 rounded-full text-xs font-medium ${getUserTypeColor(
                    card.userType
                  )}`}
                >
                  {card.userType}
                </span>
              </div>

              <div className="flex items-center space-x-2">
                <Icon name="Calendar" size={14} className="text-text-muted" />
                <span className="text-sm text-text-muted">
                  Registered: {formatDate(card.registrationDate)}
                </span>
              </div>
            </div>

            <div className="flex items-center justify-between">
              <Button
                variant="ghost"
                onClick={() =>
                  setExpandedCard(expandedCard === card.id ? null : card.id)
                }
                className="text-sm px-2 py-1 h-auto"
              >
                {expandedCard === card._id ? "Less Details" : "More Details"}
                <Icon
                  name={expandedCard === card._id ? "ChevronUp" : "ChevronDown"}
                  size={14}
                  className="ml-1"
                />
              </Button>

              <div className="flex items-center space-x-2">
                <Button
                  variant="ghost"
                  onClick={() => handleSelectCard(card)}
                  // onClick={() => onViewNFCCode(card)}
                  className="p-2"
                  title="View NFC Code"
                >
                  <Icon name="QrCode" size={16} />
                </Button>

                <Button
                  variant="ghost"
                  onClick={() => onEditAssignment(card)}
                  className="p-2"
                  title="Edit Assignment"
                >
                  <Icon name="Edit" size={16} />
                </Button>

                <Button
                  variant="ghost"
                  onClick={() => onToggleStatus(card)}
                  className="p-2"
                  title={
                    card.status === "active" ? "Restrict Card" : "Activate Card"
                  }
                >
                  <Icon
                    name={card.status === "active" ? "Ban" : "CheckCircle"}
                    size={16}
                    className={
                      card.status === "active" ? "text-warning" : "text-success"
                    }
                  />
                </Button>
              </div>
            </div>

            {expandedCard === card.id && (
              <div className="mt-4 pt-4 border-t border-border space-y-2">
                <div className="text-xs text-text-muted uppercase tracking-wide font-medium">
                  Additional Details
                </div>
                {card.department && (
                  <div className="flex justify-between">
                    <span className="text-sm text-text-muted">Department:</span>
                    <span className="text-sm text-text-primary">
                      {card.department}
                    </span>
                  </div>
                )}
                <div className="flex justify-between">
                  <span className="text-sm text-text-muted">User Email:</span>
                  <span className="text-sm text-text-primary">
                    {card.userEmail}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-sm text-text-muted">Max Shares:</span>
                  <span className="text-sm text-text-primary">
                    {card.maxShares}
                  </span>
                </div>
                {card.expiryDate && (
                  <div className="flex justify-between">
                    <span className="text-sm text-text-muted">Expires:</span>
                    <span className="text-sm text-text-primary">
                      {formatDate(card.expiryDate)}
                    </span>
                  </div>
                )}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Empty State */}
      {cards?.length === 0 && (
        <div className="text-center py-12">
          <Icon
            name="CreditCard"
            size={48}
            className="text-text-muted mx-auto mb-4"
          />
          <h3 className="text-lg font-medium text-text-primary mb-2">
            No cards found
          </h3>
          <p className="text-text-muted mb-4">
            No cards match your current filters. Try adjusting your search
            criteria.
          </p>
        </div>
      )}
    </div>
  );
};

export default CardTable;
